<template><section>
<h1>Tree 树形菜单控件</h1>
<h2>基本用法</h2>
<demo-block>
                    <div class="source" slot="source"><template>
  <nt-tree :data="treeData" @node-click="handTreeClick"></nt-tree>
</template>



</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">nt-tree</span> <span class="hljs-attr">:data</span>=<span class="hljs-string">"treeData"</span> <span class="hljs-attr">@node-click</span>=<span class="hljs-string">"handTreeClick"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-tree</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">treeData</span>: [
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"西游记"</span>,
          <span class="hljs-attr">id</span>: <span class="hljs-string">"111"</span>,
          <span class="hljs-attr">state</span>: <span class="hljs-string">"open"</span>,
          <span class="hljs-attr">children</span>: [
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"孙悟空"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"111-1"</span>
            },
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"猪八戒"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"111-2"</span>
            }
          ]
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"三国演义"</span>,
          <span class="hljs-attr">id</span>: <span class="hljs-string">"222"</span>,
          <span class="hljs-attr">state</span>: <span class="hljs-string">"open"</span>,
          <span class="hljs-attr">children</span>: [
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"关羽"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"222-1"</span>,
              <span class="hljs-attr">state</span>: <span class="hljs-string">"open"</span>,
              <span class="hljs-attr">children</span>: [
                {
                  <span class="hljs-attr">label</span>: <span class="hljs-string">"关平"</span>,
                  <span class="hljs-attr">id</span>: <span class="hljs-string">"222-1-1"</span>
                }
              ]
            },
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"张飞"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"222-2"</span>,
              <span class="hljs-attr">children</span>: [
                {
                  <span class="hljs-attr">label</span>: <span class="hljs-string">"张苞"</span>,
                  <span class="hljs-attr">id</span>: <span class="hljs-string">"222-2-1"</span>
                }
              ]
            },
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"刘备"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"222-3"</span>,
              <span class="hljs-attr">children</span>: [
                {
                  <span class="hljs-attr">label</span>: <span class="hljs-string">"阿斗"</span>,
                  <span class="hljs-attr">id</span>: <span class="hljs-string">"222-3-1"</span>
                }
              ]
            }
          ]
        }
      ]
    };
  },
  <span class="hljs-attr">methods</span>: {
    handTreeClick(item) {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">"item :"</span>, item);
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h2>可供选择</h2>
<demo-block>
                    <div class="source" slot="source"><template>
  <nt-tree ref="checktree" :data="treeCheckboxData" :showcheckbox="true" @node-click="handTreeClick"></nt-tree>
  <nt-button size="small" type="primary" @click="getAllCheckNode">获取所有选中的节点</nt-button>
  <nt-button size="small" type="primary" @click="getAllLeafCheckNode">获取所有选中叶子节点</nt-button>
</template>



</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">nt-tree</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"checktree"</span> <span class="hljs-attr">:data</span>=<span class="hljs-string">"treeCheckboxData"</span> <span class="hljs-attr">:showcheckbox</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">@node-click</span>=<span class="hljs-string">"handTreeClick"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-tree</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"small"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"getAllCheckNode"</span>&gt;</span>获取所有选中的节点<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">size</span>=<span class="hljs-string">"small"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"getAllLeafCheckNode"</span>&gt;</span>获取所有选中叶子节点<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">treeCheckboxData</span>: [
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"西游记"</span>,
          <span class="hljs-attr">id</span>: <span class="hljs-string">"111"</span>,
          <span class="hljs-attr">state</span>: <span class="hljs-string">"open"</span>,
          <span class="hljs-attr">children</span>: [
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"孙悟空"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"111-1"</span>
            },
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"猪八戒"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"111-2"</span>
            }
          ]
        },
        {
          <span class="hljs-attr">label</span>: <span class="hljs-string">"三国演义"</span>,
          <span class="hljs-attr">id</span>: <span class="hljs-string">"222"</span>,
          <span class="hljs-attr">state</span>: <span class="hljs-string">"open"</span>,
          <span class="hljs-attr">children</span>: [
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"关羽"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"222-1"</span>,
              <span class="hljs-attr">state</span>: <span class="hljs-string">"open"</span>,
              <span class="hljs-attr">children</span>: [
                {
                  <span class="hljs-attr">label</span>: <span class="hljs-string">"关平"</span>,
                  <span class="hljs-attr">id</span>: <span class="hljs-string">"222-1-1"</span>
                }
              ]
            },
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"张飞"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"222-2"</span>,
              <span class="hljs-attr">children</span>: [
                {
                  <span class="hljs-attr">label</span>: <span class="hljs-string">"张苞"</span>,
                  <span class="hljs-attr">id</span>: <span class="hljs-string">"222-2-1"</span>
                }
              ]
            },
            {
              <span class="hljs-attr">label</span>: <span class="hljs-string">"刘备"</span>,
              <span class="hljs-attr">id</span>: <span class="hljs-string">"222-3"</span>,
              <span class="hljs-attr">children</span>: [
                {
                  <span class="hljs-attr">label</span>: <span class="hljs-string">"阿斗"</span>,
                  <span class="hljs-attr">id</span>: <span class="hljs-string">"222-3-1"</span>
                }
              ]
            }
          ]
        }
      ]
    };
  },
  <span class="hljs-attr">methods</span>: {
    handTreeClick(item) {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">"item :"</span>, item);
    },
    getAllCheckNode(){
        <span class="hljs-built_in">console</span>.log(<span class="hljs-keyword">this</span>.$refs.checktree.getCheckedNode());
    },
    getAllLeafCheckNode(){
        <span class="hljs-built_in">console</span>.log(<span class="hljs-keyword">this</span>.$refs.checktree.getCheckedLeafNode());
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">data</td>
<td style="text-align:left">传递的需要渲染的tree的数据</td>
<td style="text-align:left">Array</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">showcheckbox</td>
<td style="text-align:left">是否显示复选框</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left"><code v-pre>true</code> <code v-pre>false</code></td>
<td style="text-align:left"><code v-pre>false</code></td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">node-click</td>
<td style="text-align:left">点击每一项触发的事件</td>
<td style="text-align:left">当前点击的项,该项中的isLeaf参数表示是否是叶子节点</td>
</tr>
<tr>
<td style="text-align:left">node-click</td>
<td style="text-align:left">获取所有勾选的节点</td>
<td style="text-align:left">所有勾选的节点组成的数组</td>
</tr>
<tr>
<td style="text-align:left">node-click</td>
<td style="text-align:left">获取所有勾选叶子节点</td>
<td style="text-align:left">所有勾选的叶子节点组成的数组</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  data() {
    return {
      treeData: [
        {
          label: "西游记",
          id: "111",
          state: "open",
          children: [
            {
              label: "孙悟空",
              id: "111-1",
              checked: true
            },
            {
              label: "猪八戒",
              id: "111-2",
              checked: true
            }
          ]
        },
        {
          label: "三国演义",
          id: "222",
          state: "open",
          children: [
            {
              label: "关羽",
              id: "222-1",
              state: "open",
              checked: true,
              children: [
                {
                  label: "关平",
                  id: "222-1-1"
                }
              ]
            },
            {
              label: "张飞",
              id: "222-2",
              children: [
                {
                  label: "张苞",
                  id: "222-2-1"
                }
              ]
            },
            {
              label: "刘备",
              id: "222-3",
              children: [
                {
                  label: "阿斗",
                  id: "222-3-1"
                }
              ]
            }
          ]
        }
      ],
      treeCheckboxData: [
        {
          label: "西游记",
          id: "111",
          state: "open",
          children: [
            {
              label: "孙悟空",
              id: "111-1",
              checked: true
            },
            {
              label: "猪八戒",
              id: "111-2",
              checked: true
            }
          ]
        },
        {
          label: "三国演义",
          id: "222",
          state: "open",
          children: [
            {
              label: "关羽",
              id: "222-1",
              state: "open",
              checked: true,
              children: [
                {
                  label: "关平",
                  id: "222-1-1"
                }
              ]
            },
            {
              label: "张飞",
              id: "222-2",
              children: [
                {
                  label: "张苞",
                  id: "222-2-1"
                }
              ]
            },
            {
              label: "刘备",
              id: "222-3",
              children: [
                {
                  label: "阿斗",
                  id: "222-3-1"
                }
              ]
            }
          ]
        }
      ]
    };
  },
  methods: {
    handTreeClick(item) {
      console.log("item :", item);
    },
    getAllCheckNode(){
        console.log(this.$refs.checktree.getCheckedNode());
    },
    getAllLeafCheckNode(){
        console.log(this.$refs.checktree.getCheckedLeafNode());
    }
  }
};
</script>